export const IMAGE_ASPECT_RATIO_ID = {
  // 9:16
  VERY_TALL: 'VERY_TALL',
  // 4:5
  TALL: 'TALL',
  // 1:1
  SQUARE: 'SQUARE',
  // 16:9
  WIDE: 'WIDE',
  WIDE_LARGE: 'WIDE_LARGE',
  WIDE_SMALL: 'WIDE_SMALL',
  WIDE_TINY: 'WIDE_TINY',
  // 4:5
  TALL_HQ: 'TALL_HQ'
}

export const IMAGE_ASPECT_RATIO_ID_TO_VALUE = {
  [IMAGE_ASPECT_RATIO_ID.VERY_TALL]: 177.7777778,
  [IMAGE_ASPECT_RATIO_ID.TALL]: 125,
  [IMAGE_ASPECT_RATIO_ID.SQUARE]: 100,
  [IMAGE_ASPECT_RATIO_ID.WIDE]: 56.25,
  [IMAGE_ASPECT_RATIO_ID.WIDE_LARGE]: 56.25,
  [IMAGE_ASPECT_RATIO_ID.WIDE_SMALL]: 56.25,
  [IMAGE_ASPECT_RATIO_ID.WIDE_TINY]: 56.25,
  [IMAGE_ASPECT_RATIO_ID.TALL_HQ]: 125
}

export const IMAGE_SUFFIX = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  TINY: 'tiny'
}

export const IMAGE_ASPECT_RATIO_ID_TO_SUFFIX_MOBILE_SCREEN_FOR_BOT = {
  [IMAGE_ASPECT_RATIO_ID.VERY_TALL]: IMAGE_SUFFIX.TINY,
  [IMAGE_ASPECT_RATIO_ID.TALL]: IMAGE_SUFFIX.TINY,
  [IMAGE_ASPECT_RATIO_ID.TALL_HQ]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.SQUARE]: IMAGE_SUFFIX.TINY,
  [IMAGE_ASPECT_RATIO_ID.WIDE]: IMAGE_SUFFIX.TINY,
  [IMAGE_ASPECT_RATIO_ID.WIDE_LARGE]: IMAGE_SUFFIX.TINY,
  [IMAGE_ASPECT_RATIO_ID.WIDE_SMALL]: IMAGE_SUFFIX.TINY,
  [IMAGE_ASPECT_RATIO_ID.WIDE_TINY]: IMAGE_SUFFIX.TINY
}

export const IMAGE_ASPECT_RATIO_ID_TO_SUFFIX_MOBILE_SCREEN = {
  [IMAGE_ASPECT_RATIO_ID.VERY_TALL]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.TALL]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.TALL_HQ]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.SQUARE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE_LARGE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE_SMALL]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE_TINY]: IMAGE_SUFFIX.TINY
}

export const IMAGE_ASPECT_RATIO_ID_TO_SUFFIX = {
  [IMAGE_ASPECT_RATIO_ID.VERY_TALL]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.TALL]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.TALL_HQ]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.SQUARE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE_LARGE]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.WIDE_SMALL]: IMAGE_SUFFIX.SMALL,
  [IMAGE_ASPECT_RATIO_ID.WIDE_TINY]: IMAGE_SUFFIX.TINY
}

export const IMAGE_ASPECT_RATIO_ID_TO_SUFFIX_VERY_LARGE_SCREEN = {
  [IMAGE_ASPECT_RATIO_ID.VERY_TALL]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.TALL]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.TALL_HQ]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.SQUARE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE]: IMAGE_SUFFIX.MEDIUM,
  [IMAGE_ASPECT_RATIO_ID.WIDE_LARGE]: IMAGE_SUFFIX.LARGE,
  [IMAGE_ASPECT_RATIO_ID.WIDE_SMALL]: IMAGE_SUFFIX.SMALL,
  [IMAGE_ASPECT_RATIO_ID.WIDE_TINY]: IMAGE_SUFFIX.TINY
}

export const IMAGE_EXTENSION = {
  PNG: '.png',
  JPG: '.jpg'
}

export const IMAGE_EXTENSION_TO_MIME = {
  [IMAGE_EXTENSION.PNG]: 'image/png',
  [IMAGE_EXTENSION.JPG]: 'image/jpeg'
}

export const IMAGE_COMPONENT_NAME = 'Image'
